var render = function render(){var _vm=this,_c=_vm._self._c;return _c('mdb-row',[_c('mdb-col',[_c('mdb-autocomplete',{attrs:{"data":_vm.surrogatenamelist,"label":_vm.$t('surrogate_name'),"placeholder":_vm.$t('surrogate_name')},on:{"input":_vm.getSelectValue,"search":_vm.getSelectValue},model:{value:(_vm.selectedName),callback:function ($$v) {_vm.selectedName=$$v},expression:"selectedName"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }